<template>
  <div class="dashboard-overview-wrap">
    <v-row class="overview-wrap">
      <v-col cols="12" md="9" lg="9">
        <!-- top four cards start -->
        <participation-analysis
          :dashboardData="dashboardData"
          :loadingDashboard="loadingDashboard"
        ></participation-analysis>
        <!-- top four cards end -->
        <!-- drivers cards start -->
        <driverOverview
          :dashboardData="dashboardData"
          :loadingDashboard="loadingDashboard"
        ></driverOverview>
        <!-- drivers cards end -->
        <!-- subdriver cards start -->
        <subdriver-overview
          :dashboardData="dashboardData"
          :loadingDashboard="loadingDashboard"
        ></subdriver-overview>
        <!-- subdriver cards end -->
      </v-col>
      <!-- right column -->
      <v-col cols="12" md="3" lg="3">
        <participation-report
          :dashboardData="dashboardData"
          :loadingDashboard="loadingDashboard"
        ></participation-report>
        <mental-wellness
          :dashboardData="dashboardData"
          :loadingDashboard="loadingDashboard"
        ></mental-wellness>
      </v-col>
    </v-row>

    <!-- bottom cards -->
    <v-row class="overview-wrap">
      <v-col cols="12" md="9">
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <employeesVibe
              :dashboardData="dashboardData"
              :loadingDashboard="loadingDashboard"
            ></employeesVibe>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <engagementOvertime
              :dashboardData="dashboardData"
              :loadingDashboard="loadingDashboard"
            ></engagementOvertime>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="3">
        <div class="report-overview-blank">
          <div class="wellness-wrap">
            <div class="wellness-title">Disengaged employees</div>
            <div class="wellness-body" v-if="dashboardData && dashboardData.disengaged_employees_stats && dashboardData.disengaged_employees_stats.disengaged_employees">
              <v-list v-if="dashboardData && dashboardData.disengaged_employees_stats">
                <template v-for="(item, index) in dashboardData.disengaged_employees_stats.disenageged_employees_list">
                  <v-divider :key="`${index}divider`" :inset="true"></v-divider>
                  <v-list-item :key="index" @click="viewEmp(item)">
                    <v-list-item-avatar style="overflow: visible;">
                      <div class="star-icon">
                        <v-icon v-if="item.user__user_profile__high_potential_emp">fas fa-star</v-icon>
                      </div>
                      <!-- <div class="emp-profile-image"> -->
                        <img v-if="item.profilePicture" :src="item.profilePicture" :alt="item.display_name">
                        <img v-else :src="getImgUrl('male-avatar')" :alt="item.user__display_name">
                      <!-- </div> -->
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-if="item.user__display_name">{{item.user__display_name}}</v-list-item-title>
                      <v-list-item-title v-else>--</v-list-item-title>
                      <v-list-item-subtitle v-if="item.user__email">{{item.user__email}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>--</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text>
                        <span v-if="item.driverAverage">{{item.driverAverage}}</span>
                        <span v-else>0</span>
                      </v-list-item-action-text>
                      <v-icon></v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </div>
            <div v-else style="height: 22rem;align-items: center;display: flex;padding: 0 10%;">
              Yay! You don’t have any disengaged employee
            </div>
            <div class="wellness-action" v-if="dashboardData.disengaged_employees_stats
              && dashboardData.disengaged_employees_stats.disengaged_employees"
            >
              <v-btn outlined color="primary"
                @click="viewDisengaged"
              >
                <span v-if="dashboardData.disengaged_employees_stats
                  && dashboardData.disengaged_employees_stats.disenageged_employees_list"
                >
                  +&nbsp;View&nbsp;
                  <span v-if="(dashboardData.disengaged_employees_stats.disengaged_employees - dashboardData.disengaged_employees_stats.disenageged_employees_list.length) > 0">
                    {{dashboardData.disengaged_employees_stats.disengaged_employees - dashboardData.disengaged_employees_stats.disenageged_employees_list.length}}&nbsp;more
                  </span>
                  <span v-else>
                    &nbsp;all
                  </span>
                </span>
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import OverviewMixin from './overview-mixin';
const ParticipationAnalysis = () => import(/* webpackChunkName: "ParticipationAnalysis" */ './participation-analysis');
const DriverOverview = () => import(/* webpackChunkName: "DriverOverview" */ './driver-overview');
const SubdriverOverview = () => import(/* webpackChunkName: "SubdriverOverview" */ './subdriver-overview');
const ParticipationReport = () => import(/* webpackChunkName: "ParticipationReport" */ './participation-report');
const MentalWellness = () => import(/* webpackChunkName: "MentalWellness" */ './mental-wellness');
const EmployeesVibe = () => import(/* webpackChunkName: "EmployeesVibe" */ './employees-vibe');
const EngagementOvertime = () => import(/* webpackChunkName: "EngagementOvertime" */ './engagement-overtime');

export default {
  name: 'Overview',

  mixins: [OverviewMixin],

  components: {
    ParticipationAnalysis,
    DriverOverview,
    SubdriverOverview,
    ParticipationReport,
    MentalWellness,
    EmployeesVibe,
    EngagementOvertime
  },

  data () {
    return {
      items: [
        // { header: 'Today' },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          title: 'Brunch this weekend?',
          subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?"
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
          subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend."
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
          title: 'Oui oui',
          subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?"
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
          title: 'Birthday gift',
          subtitle: "<span class='text--primary'>Trevor Hansen</span> &mdash; Have any ideas about what we should get Heidi for her birthday?"
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
          title: 'Recipe to try',
          subtitle: "<span class='text--primary'>Britta Holt</span> &mdash; We should eat this: Grate, Squash, Corn, and tomatillo Tacos."
        }
      ]
    };
  },

  methods: {
    getImgUrl (pet) {
      const images = require.context('@/assets', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    viewEmp (emp) {
      this.$router.push({ path: `/employees/view/${emp.user__user_profile__id}` }).catch(() => {});
    },
    viewDisengaged () {
      this.$router.push({ path: '/?tab=disengaged-emp-to-meet' }).catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-overview-wrap {
  .overview-wrap {
    margin: 0;
  }
  .report-overview-blank {
    margin: 12px 0 0 0;
    .wellness-wrap {
      height: 26rem;
      overflow: hidden;
      border-radius: 6px;
      background-color: var(--bg);
      // box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
      box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06), 0 4px 8px rgba(0, 0, 0, 0.1) !important;
      .wellness-title {
        padding: 16px;
        font-size: var(--content-size);
        font-size: 20px;
        color: var(--color-text);
        text-align: left;
        padding-bottom: 0;
      }
      .wellness-body {
        // padding: 16px;
        padding-top: 0;
        font-size: 14px;
        text-align: left;
        .star-icon {
          position: absolute;
          top: 4px;
          left: -6px;
          i {
            color: #fdd835 !important;
            font-size: 20px !important;
          }
        }
      }
      .wellness-action {
        text-align: center;
      }
    }
  }
}
</style>

<style scoped>
/* .plus{
  width:20px;
  height:20px;
  background: transparent;
  border-radius: 50%;
  position: absolute;
  border: 2px solid white;
  top:10px;
  right:10px;
  transition: 1s;
  -webkit-transition: 1s;
}

.plus:hover{
  transform: scale(1.1) rotate(90deg);
}

.plus p{
  padding: 0px !important;
  display:inline;
  margin:0px;
  line-height:50%;
  left:50%;
  top:45.3%;
  transform:translate(-50%,-50%);
  position:absolute;
  color: white;
}

.zoomed{
  width:100%;
} */
</style>
